;(function($) {

    $('document').ready(function() {

        //// Firm registraion dedicated form

        // Связанные селекты — выбор города

        var $citySelector = $('.firm-registration-form_cityselector');

        if ($citySelector.length > 0) {

            var $master        = $citySelector.find('.i-bound-selects__master'),
                $masterSelect  = $master.find('select'),
                getMasterValue = function () { return $masterSelect.val() },
                $slaves        = $citySelector.find('.i-bound-selects__slave');

            // Показываем все селекты

            var showEveryting = function () {
                $slaves.show().find('select').removeAttr('disabled');
            };

            // Показываем города выбранной страны, скрывая остальных

            var hideUnselectedOnes = function () {
                $slaves.filter(':not(.i-bound-selects__slave_'+ getMasterValue() +')')
                .hide()
                .find('select').attr('disabled', 'disabled');
            };

            // Делаем чёрное дело

            var toggleCityList = function () {
                showEveryting();
                hideUnselectedOnes();
            };

            $(document).on('ready', function() {
                toggleCityList();

                $masterSelect.on('change', function() {
                    toggleCityList();
                });
            });
        }
    });
})(jQuery);
